/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notification_Showing_RecentInputs */



/**
* | output |
* | --- |
* | "Showing the {count} most recent" |
*
* @param {Notification_Showing_RecentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_showing_recent = /** @type {((inputs: Notification_Showing_RecentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Showing_RecentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die ${i?.count} neuesten werden angezeigt`)
	return /** @type {LocalizedString} */ (`Showing the ${i?.count} most recent`)
});